import { Injectable } from '@angular/core';
import { Subject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from './../../environments/environment.prod';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { DataService } from './data.service';

@Injectable()
export class MainService {

  constructor(private http: Http, private DataServiceObj: DataService, private route: Router, private toastr: ToastrService) {
    this.Base_URL = environment.dataUrl;
  }
  Base_URL: any;

  //  Loader
  private AppLoaderComponent = new Subject<any>();
  ComponentMethodCallForLoader$ = this.AppLoaderComponent.asObservable();

  // All Post Request
  PostRequest(ApiName: any, body: any) {
    if (this.CheckNetworkStatus()) {
      const token = this.DataServiceObj.getUserToken();
      const headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('auth', token);
      headers.append('Access-Control-Allow-Headers', 'Content-Type');
      headers.append('Access-Control-Allow-Methods', 'GET, POST, OPTIONS');
      headers.append('Access-Control-Allow-Origin', '*');

      const options = new RequestOptions({ headers });
      return this.http.post(this.Base_URL + ApiName, body, options)
        .pipe(
          map(this.extractData),
          catchError(this.handleErrorObservable)
        );
    } else {
      this.ShowAlert('Error', 'Please check your internet connection!');
    }
  }

  NavigateToLogin() {
    this.route.navigate(['/login']);
    window.scrollTo(0, 0);
  }

  // show alert box
  ShowAlert(Value, message, timeout = 3000) {
    if (Value == 'Success') {
      this.toastr.success(message, '', { timeOut: timeout });
    }
    if (Value == 'Error') {
      this.toastr.error(message, '', { timeOut: timeout });
    }
    if (Value == 'Warning') {
      this.toastr.warning(message, '', { timeOut: timeout });
    }
    if (Value == 'Info') {
      this.toastr.info(message, '', { timeOut: timeout });
    }
    if (Value === 'Loading') {
     this.toastr.info(message, '', { disableTimeOut: true, tapToDismiss: false });
  }

  }
   ClearAlert(toast) {
    console.log('toast', toast);
    if (toast && toast.toastId) {
      this.toastr.clear(toast.toastId); // clear specific toast
    } else {
      this.toastr.clear(); // fallback: clear all toasts
    }
  }
  // Logout
  Logout() {
    this.DataServiceObj.RemoveUserToken();
    this.DataServiceObj.RemoveUserData();
  }

  HandleErrorMessages(err) {
    if (!this.CheckNetworkStatus()) {
      this.ShowAlert('Error', 'Please check your internet connection!');
    } else if (err.message === '401') {
      const message = 'You are unauthorized to access the requested resource. Please log in!';
      this.ShowAlert('Error', message);
    } else if (err.message === '400') {
      const message = 'Invalid syntax for this request was provided!';
      this.ShowAlert('Error', message);
    } else if (err.message === '404') {
      const message = 'We could not find the resource you requested!';
      this.ShowAlert('Error', message);
    } else if (err.message === '409') {
      const message = 'The request could not be completed due to a conflict with the current state of the resource!';
      this.ShowAlert('Error', message);
    } else if (err.message === '408') {
      const message = 'Request time out please try again!';
      this.ShowAlert('Error', message);
    } else {
      const message = 'Oops! Something went wrong';
      this.ShowAlert('Error', message);
    }
  }

  // check network connection
  CheckNetworkStatus() {

    if (navigator.onLine) {
      return true;
    }
    else {
      return false;
    }
  }

  // if get successful response extract response
  private extractData(res: Response) {
    if (res.status === 200) {
      const body = res.json();
      return body;
    } else {
      return {};
    }
  }

  // handle http response code
  private handleErrorObservable(error: any) {
    // 401 - unAuthorized
    if (error.status === 401) {
      return throwError(new Error(error.status));
    }
    // 500 - internal server error
    else if (error.status === 500) {
      return throwError(new Error(error.status));
    }
    // 400 - bad request
    else if (error.status === 400) {
      return throwError(new Error(error.status));
    }
    // 404 - not found
    else if (error.status === 404) {
      return throwError(new Error(error.status));
    }
    // 409 - conflict
    else if (error.status === 409) {
      return throwError(new Error(error.status));
    }
    // 408 - request timeout
    else if (error.status === 408) {
      return throwError(new Error(error.status));
    }
    else {
      return throwError(new Error(error.status));
    }

  }

  CallMethodForLoader(Status) {
    this.AppLoaderComponent.next(Status);
  }

}

